import _ from 'underscore'
import { format, differenceInMonths, parse } from 'date-fns'
import parser from 'html-react-parser'
import languagesList from '../constants/languages'
import { epagAPI } from '../API/epagAPI'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useSave } from '../Context/saveContext'
import { message } from 'antd'
import { ArrowSort, ArrowUp, ArrowDown } from '../components/ListManagement/styles'
import iso6391 from 'iso-639-1'
import { ROLES } from '../constants/constants'

export const getHeightBox = (array) => {
  const heightRule = array?.length > 0 ? 20 : 50
  return heightRule + 'px'
}

const changeOrderStatus = (prev) => {
  if (prev === 3) {
    return 1
  } else {
    return prev + 1
  }
}

export const arrowOrder = (status, setter, columName, setList, list) => {
  switch (status) {
    case 1:
      return (
        <ArrowSort
          onClick={() => {
            setter((prev) => changeOrderStatus(prev))
            setList((prev) => {
              return _.sortBy(prev, (item) => {
                return item.toString().toLowerCase()
              })
            })
          }}
          size='12'
        />
      )

    case 2:
      return (
        <ArrowUp
          onClick={() => {
            setter((prev) => changeOrderStatus(prev))
            setList((prev) =>
              _.sortBy(prev, (item) => {
                return item.toString().toLowerCase()
              }).reverse()
            )
          }}
          size='12'
        />
      )

    case 3:
      return (
        <ArrowDown
          onClick={() => {
            setter((prev) => changeOrderStatus(prev))
            setList(list)
          }}
          size='12'
        />
      )

    default:
      return <ArrowSort onClick={() => setter((prev) => changeOrderStatus(prev))} size='12' />
  }
}

export const arrayToText = (array) => {
  if (array.length > 0) {
    return array.join(', ')
  } else {
    return ''
  }
}

export const arrayToTextList = (array) => {
  if (array.length > 0) {
    return array.join('.<br>')
  } else {
    return ''
  }
}

export const arrayWithObjectsToText = (array) => {
  if (!array?.length) {
    return ''
  }
  let text = '<div style="line-height : 20px">'
  array?.map((arrayItem, indexArray) => {
    let count = 1
    for (const property in arrayItem) {
      const prevText = text + arrayItem[property]
      if (Object.keys(arrayItem).length === count) {
        if (prevText.trim().endsWith(',')) {
          text = prevText.trim().replace(/,/g, '')
        } else {
          text = prevText
        }
      } else {
        text = prevText + ', '
      }
      count += 1
    }
    if (indexArray !== array.length - 1) {
      text = text + '<br>'
    }
  })
  text = text + '</div>'
  return text
}

export const arrayWithObjectsToArray = (array, sliceTwo) => {
  const array1 = []
  array.map((arrayItem) => {
    let text = ''
    for (const property in arrayItem) {
      if (Object.keys(arrayItem).length) {
        const item = arrayItem[property]
        if (item && item !== '') {
          text = text + item + ', '
        }
      } else {
        text = text + arrayItem[property]
      }
    }
    if (text.trim().endsWith(',')) {
      text = text.trim().replace(/.$/, '.')
      if (sliceTwo === 'S') {
        text = text.slice(0, -1)
      }
    }
    array1.push(text)
  })
  return array1
}

export const tagsMapper = (array = [], skill = '', skillsEnum = {}) => {
  switch (skill) {
    case skillsEnum.languages: {
      const getCode = (name) => languagesList.find((lang) => lang.name === name)?.code
      // eslint-disable-next-line
      return array.map(({ language_name, level }) => ({ name: language_name, level, code: getCode(language_name) }))
    }
    case skillsEnum.certification:
      // eslint-disable-next-line
      return array.map(({ certifying_entity, name, retriever_date }) => ({
        // eslint-disable-next-line
        entity: certifying_entity,
        name,
        // eslint-disable-next-line
        date: retriever_date
      }))
    case skillsEnum.educationalBackground:
      // eslint-disable-next-line
      return array.map(({ institute, grade, end_date }) => ({ entity: institute, name: grade, date: end_date }))
    default:
      // eslint-disable-next-line
      return array.map(({ skill_name, level }) => ({ name: skill_name, level }))
  }
}

export const diffInText = (dateTo, dateFrom) => {
  const dif = differenceInMonths(dateTo, dateFrom)
  let difInText = ''
  if (dif <= 12) {
    difInText = `${dif + 1} mo`
  } else {
    const years = Math.floor(dif / 12)
    const months = dif - years * 12
    if (months !== 0) {
      difInText = `${years} yr ${months} mo`
    } else {
      difInText = `${years} yr`
    }
  }
  return difInText
}

export const displayDate = (date = '') => {
  const dateObj = new Date(date)
  if (dateObj.toString() === 'Invalid Date') {
    return '-'
  }
  const day = dateObj.getDate()
  const month = dateObj.getMonth() + 1
  const year = dateObj.getFullYear()
  return `${month <= 9 ? '0' + month : month}/${day <= 9 ? '0' + day : day}/${year}`
}

export const displayUTCDate = (date = '') => {
  const dateObj = new Date(date)
  if (dateObj.toString() === 'Invalid Date' || date === null) {
    return '-'
  }
  const day = dateObj.getUTCDate()
  const month = dateObj.getUTCMonth() + 1
  const year = dateObj.getUTCFullYear()
  return `${month <= 9 ? '0' + month : month}/${day <= 9 ? '0' + day : day}/${year}`
}

export const dateFormat = (DateTo, DateFrom) => {
  try {
    if (DateTo && DateTo !== 'Currently') {
      const startDate = format(parse(DateFrom, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
      const endDate = format(parse(DateTo, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
      return `${startDate} - ${endDate} (${calculatePeriod(DateTo, DateFrom)})`
    } else {
      const startDate = format(new Date(DateFrom), 'MMM yyyy')
      return `${startDate} - Currently (${calculatePeriod(DateTo, DateFrom)})`
    }
  } catch (e) {
    console.error(e)
  }
  return ''
}

const formatDate = (dateStr) => {
  if (!dateStr) {
    return ''
  }

  if (dateStr === 'Currently') {
    return dateStr
  }

  const date = new Date(dateStr)

  const month = date.getMonth() + 1
  const year = date.getFullYear()

  const formattedDate = `${(month < 10 ? '0' : '') + month}.${year}`

  return formattedDate
}

export const calculatePeriod = (startDate, endDate) => {
  let period = ''
  const formattedEndDate = formatDate(endDate)
  const isCurrently = formattedEndDate === 'Currently'

  const start = new Date(startDate)
  const end = isCurrently ? new Date() : new Date(endDate)

  const differenceInDays = Math.abs((end - start) / (1000 * 3600 * 24))
  const totalPeriodInMonths = Math.abs(differenceInDays / 30.4375)

  const years = Math.floor(totalPeriodInMonths / 12)
  const roundedMonths = Math.round(totalPeriodInMonths % 12)

  const remainingMonths = roundedMonths === 0 && years === 0 ? 1 : roundedMonths

  if (years > 0) {
    period += `${years} year${years !== 1 ? 's' : ''}`
  }

  if (remainingMonths > 0) {
    period += `${years > 0 ? ' ' : ''}${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}`
  }

  return period.trim()
}

// disable dates before given date
export const disablePastDates = (from, after) => {
  if (from && after) {
    return new Date(from) < new Date(after)
  }
  return false
}
export const disableFutureDates = (current) => {
  // Can not select dates after today
  return current && current > new Date()
}
export const isEmpty = (hook) => {
  if (hook === undefined) {
    return true
  }
  if (hook && !hook.value) {
    hook.setError(true)
    return true
  }
  if (hook?.value && hook.value.trim() === '') {
    hook.setError(true)
    return true
  }
  return false
}

export const validateFields = (hooks) => {
  return hooks.map((hook) => isEmpty(hook)).some((item) => item)
}

export const removeTagByIndex = (index, setter) => {
  setter((prevState) => {
    const list = [...prevState]
    list.splice(index, 1)
    return list
  })
}

export const removeSkillByIndex = (index, skill, setter) => {
  setter((prevState) => ({
    ...prevState,
    [skill]: prevState[skill].filter((_, i) => i !== index)
  }))
}

export const removeSkillAndUpdateSaved = (index, currentSkills, initialState, isSavedChangeSetter) => {
  const removedSkill = currentSkills[index].skill_name
  const isRemovedSkillNew = !initialState.some((skill) => skill.skill_name === removedSkill)

  const updatedSkills = [...currentSkills]
  updatedSkills.splice(index, 1)

  if (isRemovedSkillNew) {
    isSavedChangeSetter(false)
  }

  return updatedSkills
}

export const updateSkillsByMode = (mode, listSkills, newList) => {
  if (newList?.length > 0 && (mode === 'programming' || mode === 'DB')) {
    return listSkills.values.concat(newList)
  }
  return listSkills.values
}

export const groupVariousCollections = (collections) => {
  const data = collections.flatMap(({ values }) => values).flat()
  return { values: data }
}

export const capitalizeList = (list) => {
  return list.map((e) => e.charAt(0).toUpperCase() + e.slice(1))
}

export const getItemToRemoveOriginial = (itemToRemove, charSplit) => {
  let valueItem = itemToRemove.trim()
  valueItem = valueItem.split(charSplit)[0]
  if (valueItem.endsWith('.')) {
    valueItem = valueItem.slice(0, -1)
  }
  return valueItem
}

export const parseItemMessage = (textMessage, stringMessage, key = '[[item]]') => {
  return parser(textMessage.replace(key, stringMessage))
}

export const isEmailAddress = (email) => {
  return /[A-z0-9.]+@endava.com/g.test(email)
}

export const sortByStartedDate = (array) => {
  if (array) {
    array.sort(function (x, y) {
      return new Date(y.started_date) - new Date(x.started_date)
    })
  }
  return array
}

export const removeTemplateFromArray = (array, id) => {
  return array.filter((value) => value._id !== id)
}

export const onlyLettersToInput = (target, field) => {
  const { value } = target

  const re = /^[a-zA-Z\s]*$/
  if (value === '' || re.test(value)) {
    field.setValue(value)
  }
}

export const validateSpelling = async (token, text, setError, setErrorMessage) => {
  if (token == null) return false
  setErrorMessage('')
  return await epagAPI
    .GetSpellErrors(text, token)
    .then((response) => {
      if (!response.allowedSave) {
        setErrorMessage(
          ': ' +
          response.errors
            .map((error) => {
              let correction = `"${error.token}" -> Duplicated`
              if (error.type !== 'RepeatedToken') {
                correction = `"${error.token}" -> "${error.suggestions[0].suggestion}"`
              }
              return correction
            })
            .join(', ') +
          '.'
        )
        if (setError) {
          setError(true)
        }
      }
      return !response.allowedSave
    })
    .catch((error) => {
      console.log(error)
      return false
    })
}
/**
 * Creates a useEffect hook running the callback only when the component is mounted
 * @param {Function} callback
 * @param {*[]} dependencies
 */
export const useIfMountedEffect = (callback, dependencies = []) => {
  let isMounted = true
  useEffect(() => {
    if (isMounted && callback) {
      callback()
    }
  }, dependencies)
  return () => {
    isMounted = false
  }
}

/**
 * Compares two objects by attribute `attrib` in ASCII order
 * @param {Object.<string, string>} a
 * @param {Object.<string, string>} b
 * @param {string} attrib
 */
export const compare = (a, b, attrib) => {
  if (a[attrib] < b[attrib]) {
    return -1
  }
  if (a[attrib] > b[attrib]) {
    return 1
  }
  return 0
}

/**
 * Compares two contributors by name
 */
export const contributorsCompare = (contributor, nextContributor) => {
  return compare(contributor, nextContributor, 'name')
}

/*
 * Navigates to default URL when userId is equal to current logged user
 * @param {string} userId - id to check for changes, without Endava domain
 * @param {string} to - relative URL, defaults to '/'
 */
export const useNavigateToWhenOwnView = (userId, to = '/') => {
  const navigate = useNavigate()
  const { userProfile } = useSave()
  useEffect(() => {
    if (!(userProfile && userId)) return
    if (`${userId}@endava.com`.toLowerCase() === userProfile.email.toLowerCase()) {
      navigate(to, { replace: true })
    }
  }, [userProfile, userId])
}

export const setMessageWarning = (error, value) => {
  const placeholder = '[[placeholder]]'
  message.warning(error.includes(placeholder) ? error.replace(placeholder, value) : error)
}

export const sortSingleValuesList = (list) =>
  list.slice().sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))

// TODO: Refactor this to use permissions
export const isAdminRole = (role = '', userPermissionsQuantity = 0, permissionsQuantity = 0) =>
  role === 'Admin' && userPermissionsQuantity === permissionsQuantity

export const getLanguageCode = (language) => {
  const isoCode = iso6391.getCode(language)
  return isoCode
}

export const formatPercentage = (value) => {
  if (value % 1 === 0) return value
  return value.toFixed(2)
}

export function cleanString(string) {
  return string.toLowerCase().replace(/\s/g, '')
}

export function searchCaseInsensitive(array, string) {
  return array.find((item) => {
    return cleanString(string) === cleanString(item)
  })
}

export function removedValueObj(value, name, filterData) {
  if (['lastUpdateFrom', 'lastUpdateTo'].includes(name)) {
    return { ...filterData, [name]: '' }
  }
  if (name === 'completion') {
    return { ...filterData }
  }
  return ({ ...filterData, [name]: filterData[name].filter(item => item !== value) })
}

/**
 *
 * @param {string} name  - role name
 * @returns true if the role name is one of the defined role in constants ROLES
 */
export function isSystemRole(name) {
  return Object.values(ROLES).includes(name)
}
